import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import _ from 'lodash';
import actions from 'api/actions';
import PlanPurchaseModal from 'components/shared/plan-purchase-modal';
import PoweredByStripe from 'assets/img/powered_by_stripe.png';
import LearningCenterContactModal from 'components/containers/unauthenticated/services/learning-center-details/contact-modal';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import MainHeader, { HeaderText } from 'components/shared/landing/main-header';
import styles from '../landing-pages/styles.module.scss';

function openIntercomMessage(message) {
  return () => {
    if (window && window.Intercom) {
      window.Intercom('showNewMessage', message);
    }
  };
}

class CampTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPlanId: null,
    };

    this.startPlanPurchase = this.startPlanPurchase.bind(this);
    this.onFinishPlanPurchase = this.onFinishPlanPurchase.bind(this);
    this.onCancelPlanPurchase = this.onCancelPlanPurchase.bind(this);
    this.dismissPurchaseConfirmation =
      this.dismissPurchaseConfirmation.bind(this);
    this.onOpenContactModal = this.onOpenContactModal.bind(this);
    this.onDismissContactModal = this.onDismissContactModal.bind(this);
  }

  componentDidMount() {
    const { learningCenterId } = this.props;

    const plansRequest = actions.get('plans').then(r => {
      const plans = _.filter(
        r.data,
        plan =>
          _.includes(
            plan.learning_center_ids,
            parseInt(learningCenterId, 10),
          ) || plan.learning_center_ids.length === 0,
      );
      this.setState({ plans });
    });

    const learningCenterRequest = actions
      .get('learning_centers', learningCenterId)
      .then(r => this.setState({ learningCenter: r.data }))
      .catch(e => Sentry.captureException(e));

    Promise.all([plansRequest, learningCenterRequest]);
  }

  startPlanPurchase(planId) {
    this.setState({ selectedPlanId: planId });
  }

  onCancelPlanPurchase() {
    this.setState({ selectedPlanId: null });
  }

  onFinishPlanPurchase() {
    this.setState({ selectedPlanId: null, purchasedPlan: true });
  }

  dismissPurchaseConfirmation() {
    this.setState({ purchasedPlan: false });
  }

  onOpenContactModal() {
    this.setState({ contactModalOpen: true });
  }

  onDismissContactModal() {
    this.setState({ contactModalOpen: false });
  }

  render() {
    const {
      selectedPlanId,
      purchasedPlan,
      contactModalOpen,
      plans,
      learningCenter,
    } = this.state;

    const {
      headerTitle,
      headerSubtext,
      headerImage,
      whoContent,
      whatContent,
      whenContent,
      planId,
    } = this.props;

    if (!plans || !learningCenter) {
      return <div />;
    }

    const selectedPlan = selectedPlanId
      ? _.find(plans, ['id', selectedPlanId])
      : null;

    return (
      <div className="w-100">
        <MainHeader
          style={styles.astronautValueProp}
          header={
            <HeaderText className={styles.headerText}>{headerTitle}</HeaderText>
          }
          subtext={headerSubtext}
          onButtonClick={() => this.startPlanPurchase(planId)}
          buttonText="Sign Up"
          buttonClassName="apple"
          image={headerImage}
          flip
        />
        <section className={styles.aboutCourse}>
          <div className={styles.container}>
            <div className={styles.row}>
              <div className={styles.tldrColumn}>
                <h2>Who</h2>
              </div>
              <div className={styles.mainColumn}>{whoContent}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.tldrColumn}>
                <h2>When</h2>
              </div>
              <div className={styles.mainColumn}>{whenContent}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.tldrColumn}>
                <h2>What</h2>
              </div>
              <div className={styles.mainColumn}>{whatContent}</div>
            </div>
            <div className={styles.contactRow}>
              <button
                type="button"
                onClick={() => this.startPlanPurchase(planId)}
                className={styles.contactInstructorGreen}
              >
                Get Started
              </button>
            </div>
          </div>
        </section>
        <section className={styles.aboutInstructor}>
          <div className={styles.container}>
            <div className={styles.row}>
              <div className={styles.tldrColumn}>
                <h2>About {learningCenter.instructor_first_name}</h2>
                <img
                  className={styles.roundImage}
                  src={learningCenter.image_file_name}
                  alt={`chosen avatar for ${learningCenter.title}`}
                />
                {learningCenter.instructor_credentials.slice(0, 2).map(cred => (
                  <div key={cred} className={styles.credential}>
                    {cred}
                  </div>
                ))}
              </div>
              <div className={styles.mainColumn}>
                <p className={styles.instructorDescription}>
                  {learningCenter.instructor_description}
                </p>
                <blockquote className={styles.instructorQuote}>
                  {learningCenter.instructor_quote}
                </blockquote>
                <div className={styles.contactRow}>
                  <button
                    type="button"
                    onClick={this.onOpenContactModal}
                    className={styles.contactInstructor}
                  >
                    Contact {learningCenter.instructor_first_name}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.reminders}>
          <div className={styles.container}>
            <div className={styles.row}>
              <div className={styles.tldrColumn}>
                <h2>Reminders</h2>
              </div>
              <div className={styles.mainColumn}>
                <h3>Device &amp; Internet</h3>
                <p>
                  Since instruction takes place primarily using{' '}
                  <Link to="/online-platform">Unyted's Online Platform</Link>,
                  learners will need some sort of device capable of runnning a
                  modern web browser and an internet connection. You can use a
                  phone, tablet, or laptop!
                </p>
                <h3>First session onboarding </h3>
                <p>
                  Each learner will be given an onboarding session to meet
                  educator and get introduced to TEAM Method. These *may* be
                  included in educators' programs. For 1 on 1 sessions, they'll
                  need to be scheduled by the parent.
                </p>
                <h3>
                  Secure Payments
                  <a href="https://stripe.com" target="_blank" rel="noreferrer">
                    <img
                      className="ml-3"
                      src={PoweredByStripe}
                      alt="Powered By Stripe"
                    />
                  </a>
                </h3>
                <p>
                  All payments are processed by our partner, Stripe. Stripe is a
                  secure payment platform using the same industry-standard
                  security and encryption you're used to!
                </p>
              </div>
            </div>
          </div>
        </section>
        {selectedPlan && (
          <PlanPurchaseModal
            open={selectedPlan}
            onFinish={this.onFinishPlanPurchase}
            dismiss={this.onCancelPlanPurchase}
            plan={selectedPlan}
            learningCenterId={learningCenter.id}
          />
        )}
        <Modal
          size="md"
          isOpen={purchasedPlan}
          toggle={this.dismissPurchaseConfirmation}
        >
          <ModalHeader toggle={this.dismissPurchaseConfirmation}>
            <h3>Thank you for your purchase!</h3>
          </ModalHeader>
          <ModalBody>
            <p>
              <strong>Please check your email*</strong> for next steps.
            </p>
            <p>
              If you have any further questions, feel free to&nbsp;
              <button
                className="link text-blue"
                onClick={openIntercomMessage(
                  "I'm a parent and I just purchased a Unyted Learning Center service",
                )}
              >
                contact us here
              </button>
              .
            </p>
            <p>*You may need to check your spam folder.</p>
          </ModalBody>
        </Modal>
        <LearningCenterContactModal
          open={contactModalOpen}
          dismiss={this.onDismissContactModal}
          learningCenterId={learningCenter.id}
          instructorName={learningCenter.instructor_first_name}
        />
      </div>
    );
  }
}

export default CampTemplate;
